export default "__VITE_ASSET__2886ada8__"